import { createReducer, PayloadAction } from '@reduxjs/toolkit'
import * as bulkOperationActions from '../actions/bulkOperationsActions'
import { NoteBulkRequest, NoteBulkStatusResponse } from '../api'
import { BulkRefinalizeRequest, BulkRefinalizeResponse } from '../api/refinalize'
import { BulkRedoRequest, BulkRedoStatusResponse } from '../api/redo'
import { BulkGetStatusRequest, BulkGetStatusResponse } from '../api/status'
import { BulkOperationsViewStore } from './states'
import { BulkCancelRequest, BulkCancelStatusResponse } from '../api/cancel'
import { BulkOperationDownloadRequest, 
  BulkOperationDownloadResponse, 
  BulkOperationRequest, 
  BulkOperationResponse, 
  BulkOperationStatusRequest, 
  BulkOperationStatusResponse } from '../api/bulkOperations'

const initialState: BulkOperationsViewStore = {
  tabIndex: 0,
  bulkNoteStatusResponse: {} as NoteBulkStatusResponse,
  bulkRedoStatusResponse: {} as BulkRedoStatusResponse,
  bulkCancelStatusResponse: {} as BulkCancelStatusResponse,
  bulkGetStatusResponse: {} as BulkGetStatusResponse,
  bulkRefinalizeResponse: {} as BulkRefinalizeResponse,
  isLoading: false,  
  bulkOperationResponse: {} as BulkOperationResponse,
  bulkOperationStatusResponse: {} as BulkOperationStatusResponse,
  bulkOperationDownloadResponse: {} as BulkOperationDownloadResponse,
}

export const bulkOperationsView = createReducer<BulkOperationsViewStore>(initialState, {
  [bulkOperationActions.bulkCommentRequest.type]: (state, action: PayloadAction<NoteBulkRequest>) => {
    return state
  },
  [bulkOperationActions.bulkCommentStatusReceived.type]: (state, action: PayloadAction<NoteBulkStatusResponse>) => {
    state.bulkNoteStatusResponse = action.payload
    return state
  },
  [bulkOperationActions.bulkRedoRequest.type]: (state, action: PayloadAction<BulkRedoRequest>) => {
    return state
  },
  [bulkOperationActions.bulkRedoStatusResponse.type]: (state, action: PayloadAction<BulkRedoStatusResponse>) => {
    state.bulkRedoStatusResponse = action.payload
    return state
  },
  [bulkOperationActions.bulkCancelRequest.type]: (state, action: PayloadAction<BulkCancelRequest>) => {
    return state
  },
  [bulkOperationActions.bulkCancelStatusResponse.type]: (state, action: PayloadAction<BulkCancelStatusResponse>) => {
    state.bulkCancelStatusResponse = action.payload
    return state
  },
  [bulkOperationActions.bulkGetStatusRequest.type]: (state, action: PayloadAction<BulkGetStatusRequest>) => {
    return state
  },
  [bulkOperationActions.bulkGetStatusResponse.type]: (state, action: PayloadAction<BulkGetStatusResponse>) => {
    state.bulkGetStatusResponse = action.payload
    return state
  },
  [bulkOperationActions.bulkResultsReset.type]: (state, action: PayloadAction<any>) => {
    state.bulkRefinalizeResponse.response = []
    state.bulkNoteStatusResponse.valid = false
    state.bulkRedoStatusResponse.valid = false
    state.bulkCancelStatusResponse.valid = false
    state.bulkGetStatusResponse.valid = false
    state.bulkRefinalizeResponse.valid = false
    state.bulkOperationResponse = {} as BulkOperationResponse
    state.bulkOperationStatusResponse = {} as BulkOperationStatusResponse
    state.bulkOperationDownloadResponse = {} as BulkOperationDownloadResponse
    return state
  },
  [bulkOperationActions.tabIndexChange.type]: (state, action: PayloadAction<number>) => {
    state.tabIndex = action.payload
    return state
  },
  [bulkOperationActions.bulkRefinalizeRequest.type]: (state, action: PayloadAction<BulkRefinalizeRequest>) => {
    return state
  },
  [bulkOperationActions.bulkRefinalizeReceived.type]: (state, action: PayloadAction<BulkRefinalizeResponse>) => {
    state.bulkRefinalizeResponse = action.payload
    return state
  },
  [bulkOperationActions.bulkOperationRequest.type]: (state, action: PayloadAction<BulkOperationRequest>) => {
    state.isLoading = true
    return state
  },
  [bulkOperationActions.bulkOperationStatusRequest.type]: (state, action: PayloadAction<BulkOperationStatusRequest>) => {
    state.isLoading = true
    return state
  },
  [bulkOperationActions.bulkOperationStatusResponse.type]: (state, action: PayloadAction<BulkOperationStatusResponse>) => {
    state.isLoading = false
    state.bulkOperationStatusResponse = action.payload
    return state
  },
  [bulkOperationActions.bulkOperationDownloadResultRequest.type]: (state, action: PayloadAction<BulkOperationDownloadRequest>) => {
    state.isLoading = true
    return state
  },
  [bulkOperationActions.bulkOperationDownloadResultResponse.type]: (state, action: PayloadAction<BulkOperationDownloadResponse>) => {
    state.isLoading = false
    state.bulkOperationDownloadResponse = {} as BulkOperationDownloadResponse
    return state
  }
})
